import React from "react";
import { TriggeredHook } from "sonobello.utilities.react";

import { Token } from "../../../Models/Authentication";
import UserContextValueProvider from "../../Providers/Value/UserContextValueProvider";
import { AuthenticationCard } from "../Components/AuthenticationCard";
import SsoAuthenticationStep, { IOAuthLoginStepProps } from "../Components/AuthenticationForms/SsoAuthenticationStep";
import SsoForm from "../Components/AuthenticationForms/SsoForm";
import DiamondIcon from "../Components/DiamondIcon";
import { ILoginStepProps } from "../Components/LoginProcess";
import VersionFooter from "../Components/VersionFooter";
import useGetGemOAuthToken from "../Hooks/UseGetGemOAuthToken";
import useGetOAuthCode from "../Hooks/UseGetOAuthCode";
import IAuthorizationStepProps from "../Types/IAuthorizationStepProps";
import UserContextIdentityRetriever from "./UserIdentityRetriever";

const useGetOAuthToken: TriggeredHook<Token, undefined, string> = () =>
  useGetGemOAuthToken({ UseGetCode: useGetOAuthCode });

const SsoAuthenticationCard: IOAuthLoginStepProps["LoginForm"] = props =>
  AuthenticationCard({
    headerText: "GEM",
    headerIcon: DiamondIcon({}),
    footer: VersionFooter({}),
    salutation: "Please click the below button to login with your Sono Bello account.",
    children: UserContextIdentityRetriever({ children: SsoForm(props) })
  });

const SsoAuthenticationCardStep: React.FC<IAuthorizationStepProps<Token> & ILoginStepProps> = props =>
  SsoAuthenticationStep({ ...props, LoginForm: SsoAuthenticationCard, useGetOAuthToken });

/** A login step which renders a user credentials form, obtains the security token via the JWT method,
 * and writes the obtained token to the UserContext.
 */
const UserContextOAuthLoginStep: React.FC<ILoginStepProps> = UserContextValueProvider<
  IAuthorizationStepProps<Token>,
  IAuthorizationStepProps<Token> & ILoginStepProps
>({
  Component: SsoAuthenticationCardStep,
  map: ({ user, setToken }) => ({ isIdentityReady: Boolean(user?.id), setAuthorization: setToken })
});

export default UserContextOAuthLoginStep;
